export const ONBOARDING_SYSTEM_SERVICE_USER = 'onboarding_tool'

export const WIDGET_SPECIALIZATION_ELIGIBILITY_CRITERIA_SETTINGS =
  'specialization-eligibility-criteria-settings'
export const WIDGET_SPECIALIZATION_ELIGIBILITY_CRITERIA_VIEW =
  'specialization-eligibility-criteria-view'
export const WIDGET_SPECIALIZATION_ELIGIBILITY_CRITERIA_TAB = 'specialization-eligibility-criteria'

export const WIDGET_EPI_CODES_TAB = 'epi-codes'
export const WIDGET_EPI_CODES_VIEW = 'epi-codes-view'

export const TABLE_PAGINATION_OPTIONS = [
  { key: 5, value: '5' },
  { key: 10, value: '10' },
  { key: 15, value: '15' },
]

export const DRAFT_SYSTEM_PARTNER = 'new-6c3abfa6-db51-41dc-923a-a8620ad67373'
